import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { Constants } from 'src/app/shared/model/Constants';
import { Employee } from 'src/app/feature-module/employees/models/Employee';
import { EmployeeSearchResultItem } from '../models/EmployeeSearchResultItem';
import { SearchEmployeesCriteria } from '../models/SearchEmployeesCriteria';
import { EmployeeCompany } from '../models/EmployeeCompany';
import { EmployeeCompanySearchResultItem } from '../models/EmployeeCompanySearchResultItem';
import { SearchEmployeeCompaniesCriteria } from '../models/SearchEmployeeCompaniesCriteria';
import { AssociatedEmployeeToEmployeeCompanyRequest } from '../models/AssociatedEmployeeToEmployeeCompanyRequest';


@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient,
    private configService: ConfigService) {

  }

  public storeEmployee(data: Employee): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'Employee', data);
  }

  public associateEmployeeToEmployeeCompany(data: AssociatedEmployeeToEmployeeCompanyRequest): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'Employee/EmployeeCompany/associate', data);
  }

  public getEmployee(id: number): Observable<Employee> {
    return this.http.get<Employee>(
      this.configService.PortalWebApiUrl + 'Employee/' + id);
  }

  public searchEmployees(criteria: SearchEmployeesCriteria): Observable<EmployeeSearchResultItem[]> {
    return this.http.post<EmployeeSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'Employee/search', criteria);
  }

  public getAllEmployeesList() : Observable<EmployeeSearchResultItem[]>{
    
    const getAllCriteria :  SearchEmployeesCriteria =
    {
      text:'',
      withInspectionRoleAllowed: false,
      withTechnicianRoleAllowed: false,
      withAssemblyRoleAllowed: false,
      withEmployeeTechnicianAllowed: false,
      withEmployeeMeritoricAllowed: false,
      withPartsHandlingEmployeeAllowed: false,
      onlyInternalEmployee: false,
      associatedEmployeeCompanyId: 0,
      pageNumber: 1,
      rowsPerPage: Constants.MaxInt,
    };
    
    return this.searchEmployees(getAllCriteria);
  }

  public getEmployeeCompany(id: number): Observable<EmployeeCompany> {
    return this.http.get<EmployeeCompany>(
      this.configService.PortalWebApiUrl + 'Employee/EmployeeCompany/' + id);
  }

  public storeEmployeeCompany(data: EmployeeCompany): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'Employee/EmployeeCompany', data);
  }

  public searchEmployeeCompanies(criteria: SearchEmployeeCompaniesCriteria): Observable<EmployeeCompanySearchResultItem[]> {
    return this.http.post<EmployeeCompanySearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'Employee/EmployeeCompany/search', criteria);
  }

}
